import App from '../app';
import events from '../events';
import { PRODUCT_ADDED_TO_CART } from '../../../vendor/sepia/shop/src/UI/Boutique/events';
import { trackAddToCart, trackProductView } from '../../../vendor/sepia/shop/src/UI/tracking';
import Product from '../../../vendor/sepia/shop/src/UI/Boutique/pages/Product/ProductPage';

require('publicPath');

const app = new App();
const options = window._sharedData.entry_data;
const $ = require('jquery');

trackProductView(options.product, 'Detalles');
const ProductGallery = require('product-gallery');
const FinanceWidget = require('../financeWidget/FinanceWidget');

require('fresco');

FinanceWidget(window.installmentsData);

const product = new Product(window._sharedData.entry_data.product, {
  priceSelector: '',
  ratingEnabled: window._sharedData.entry_data.allow_product_review,
  onAddCartSuccess,
});

const gallery = new ProductGallery(
  $('.product-details-img--sm'),
  $('.product-details-img--mobile')
);

product.init();

function onAddCartSuccess(response) {
  events.emit(PRODUCT_ADDED_TO_CART, response);
  $('.cart-link').find('.badge').text(response.cart.productsCount).removeClass('hide');

  trackAddToCart(response);
}

// social buttons
$('.btn-social').click(function (event) {
  event.preventDefault();
  const $a = $(this);
  const width = 500;
  const height = 400;
  const left = ($(window).width() - width) / 2;
  const top = ($(window).height() - height) / 2;
  const url = this.href;
  const opts = `${
    'status=1' + ',width='
  }${width},height=${height},top=${top},left=${left}`;
  window.open(url, $a.data('title'), opts);
  return false;
});

// Info pages
$('.modal-page').on('click', function (event) {
  event.preventDefault();
  require('bootstrap-modal-remote/modalRemote');
  const $modal = $('#modal-info');
  $modal.modalRemote({
    url: $(event.currentTarget).attr('href'),
    method: 'get',
    callbacks: {
      onContentLoaded(json) {
        $modal.find('.modal-title').html(json.title);
        $modal.find('.modal-body').html(json.body);
      },
    },
  });
});
